import React, { Component } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

import ArrowLSVG from '../../images/products/events/new/ArrowL.svg';
import ArrowRSVG from '../../images/products/events/new/ArrowR.svg';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Link = styled.a`
  width: 85vw;
  margin-top: 50px;
  opacity: ${ ({ center }) => (center ? 1 : 0.5) };
  transition: all 0.3s;
  ${ ({ darken }) => darken && 'opacity: 1;' };
  ${ ({ darken }) => darken && 'filter: brightness(50%);' };

  &:hover {
    opacity: ${ ({ darken }) => (darken ? 0.5 : 1) };
    ${ ({ center, isRight }) =>
      center ? null : `cursor: ${ isRight ? 'e-resize' : 'w-resize' }` };
  }
`;

const Wrapper = styled.div`
  ${ ({ darken }) =>
    darken &&
    `
    & .slick-active a {
      filter: brightness(100%);
    }
  ` };

  ${ ({ arrows }) =>
    arrows &&
    `
    & .slick-prev:before,
    & .slick-next:before {
      display: none !important;
    }

    & .slick-prev {
      left: 140px;
      top: calc(50% + 25px);

      @media (max-width: 900px) {
        left: 15px;
      }
    }

    & .slick-next {
      right: 140px;
      top: calc(50% + 25px);

      @media (max-width: 900px) {
        right: 15px;
      }
    }
  ` };
`;

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: auto;
`;

const Arrow = styled.div`
  background-color: #f2f7fa !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1) !important;
  z-index: 10;
`;

export default class CustomSlider extends Component {
  state = {
    slideIndex: 0
  };

  navigation = isRight => {
    isRight ? this.slider.slickNext() : this.slider.slickPrev();
  };

  render () {
    const { slideIndex } = this.state;
    const {
      imgSrc,
      imgSrcSet,
      centerPadding,
      arrows,
      darken,
      urls
    } = this.props;
    const settings = {
      ...(arrows && {
        prevArrow: (
          <Arrow>
            <img alt='' src={ ArrowLSVG } />
          </Arrow>
        ),
        nextArrow: (
          <Arrow>
            <img alt='' src={ ArrowRSVG } />
          </Arrow>
        )
      }),
      centerMode: true,
      dots: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: centerPadding || '20%',
      draggable: false,
      beforeChange: (current, next) => this.setState({ slideIndex: next })
    };
    const count = imgSrc ? imgSrc.length - 1 : 0;
    const root = this;
    const src = imgSrcSet || imgSrc;
    return (
      <Wrapper arrows={ arrows } darken={ darken }>
        <Slider ref={ slider => (this.slider = slider) } { ...settings }>
          { src &&
            src.map((s, i) => {
              const center = slideIndex === i;
              let isRight = slideIndex < i;

              if (slideIndex === count && i === 0) {
                isRight = true;
              } else if (slideIndex === 0 && i === count) {
                isRight = false;
              } else {
                isRight = slideIndex < i;
              }
              const onClick = e => {
                if (!center) {
                  root.navigation(isRight);
                  e.preventDefault();
                }
              };
              return (
                <Link
                  key={ i }
                  onClick={ onClick }
                  isRight={ isRight }
                  center={ center }
                  darken={ darken }
                  href={ urls[i] }
                  target='_blank'
                  rel='noreferrer'
                >
                  <Image
                    { ...(typeof s === 'string'
                      ? { src: s }
                      : {
                          srcSet: `${ imgSrcSet[i]._1x } 1x, ${
                            imgSrcSet[i]._2x
                          } 2x,${ imgSrcSet[i]._3x } 3x`
                        }) }
                  />
                </Link>
              );
            }) }
        </Slider>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Slider.js